import React, { useState } from 'react';
import SearchBar from '../explore/searchBar/searchBar';
import {useTranslation} from "react-i18next";

function filterSearch(contacts, search) {
  if(search === "") return contacts;

  const s = search.toUpperCase();

  return contacts.filter(c => {
    return (c.firstname + " " + c.lastname).toUpperCase().replace('É','E').includes(s)
  });
}

function settings_is_focused(id, focus) {
  return (focus[id] || {}).focus_enabled;
}

function settings_is_notification(id, focus) {
  return (focus[id] || {}).notification_enabled;
}

function ContactFocus({ routeEnd, contacts, notify, focus, mode }) {

  const { t } = useTranslation();

  const [contacts_s, updateContacts] = useState(() => {
    if (mode === "show") {
      return contacts.filter(x =>
	settings_is_focused(x.id, focus)
	|| settings_is_notification(x.id, focus)
      )
    }
    return contacts;
  });

  const [search, setSearch] = React.useState("");
  const [active_display, setActiveDisplay] = React.useState(false);

  const starValue = (c) => c.new_star !== undefined ? c.new_star : settings_is_focused(c.id, focus)
  const notificationValue = (c) => c.new_notification !== undefined ? c.new_notification : settings_is_notification(c.id, focus);

  function flag(id, cb) {
    if (mode === "show") return;

    // should be contacts?!
    const new_contacts = contacts_s.map(x => {
      return x.id === id ? cb(x) : x;
    });

    notify(new_contacts);
    updateContacts(new_contacts);
  }

  function setFocusStar(id) {
    return flag(id, (x) => {
      return {...x, new_star: !starValue(x)};
    })
  }

  function setNotification(id) {
    return flag(id, (x) => {
      return {...x, new_notification: !notificationValue(x)};
    })
  }

  function toggleDisplay(){
    if (mode === "show") return;
    setActiveDisplay(!active_display);
  }

  let filtered_contacts = contacts_s;

  if (active_display) {
    filtered_contacts = contacts_s.filter(c =>
      settings_is_focused(c.id, focus)
      || settings_is_notification(c.id, focus)
      || c.new_notification
      || c.new_star
    )
  }

  filtered_contacts = filterSearch(filtered_contacts, search);

  let view;
  if(mode === "edit"){
    view = <>
    <div className="c-showedit_selectAll">
      <input type="checkbox" style={{cursor: "pointer", marginRight: "5px", height: "18px"}} onClick={toggleDisplay} />
      { t("Show active elements only") }
    </div>
    </>
  }

  return (
    <>
      <div className="c-container_search-bar">
        <SearchBar value={search} handleChange={e => setSearch(e.target.value)}/>
      </div>
      {view}
      <div className={`c-container_infos main-data container-focus-mode-${mode}`}>
          <div className="focus-contact-list">
          { filtered_contacts.map(c => {
            return <div key={c.id} className="focus-contact">
              <div className="focus-contact-img-wrapper">
                <img src={c.img} alt="profile" />
                <div className={"focus-star" + (starValue(c) ? " active" : "")}
                   onClick={() => setFocusStar(c.id)} />
                <div className={"notify-icon" + (notificationValue(c) ? " active" : "")}
                     onClick={() => setNotification(c.id)} />
              </div>
              <div className="focus-contact-fullname">{c.firstname} {c.lastname}</div>
            </div>
          }) }
        </div>
      </div>
    </>
  )
}


export default ContactFocus;
